export const Apps = {
  state: {
    lang: "zh-MO",
    isLoading: false,
  },
  mutations: {
    setLang(state, value) {
      state.lang = value;
    },
    setLoading(state) {
      state.isLoading = true;
    },
    setLoaded(state) {
      state.isLoading = false;
    },
  },
  namespaced: true,
};
